'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.provider('PsobAlertStore', (StoreTemplate, localStorageEnabled) => {
  const LOCALSTORAGE_KEYS = {
    accountHash: 'mbr.accountHash',
    psobAlerts: 'psob.alert'
  };

  let psobAlert = {
    data: {
      alertKey: '',
      totalAlertCount: 0,
      attributes: {}
    }
  };

  let accountHash = '';

  if (localStorageEnabled) {
    accountHash = localStorage.getItem(LOCALSTORAGE_KEYS.accountHash);

    if (accountHash) {
      psobAlert.data = JSON.parse(localStorage.getItem(`${accountHash}.${LOCALSTORAGE_KEYS.psobAlerts}`));
    }
  }

  let template = StoreTemplate.extend({
    initFn: () => {
    },
    getterFns: {
      getPsobAlert: () => {
        return psobAlert;
      },
      isPsobAlertSet: () => {
        return localStorageEnabled && localStorage.getItem(`${accountHash}.${LOCALSTORAGE_KEYS.psobAlerts}`);
      }
    },
    dispatcherListeners: {
      'psob:alertLoaded': (alertData) => {
        psobAlert = alertData;
        if (localStorageEnabled) {
          accountHash = localStorage.getItem(LOCALSTORAGE_KEYS.accountHash);

          if (psobAlert.alertKey === 'priority.unread.psob') {
            localStorage.setItem(`${accountHash}.${LOCALSTORAGE_KEYS.psobAlerts}`, JSON.stringify(alertData));
          } else {
            localStorage.removeItem(`${accountHash}.${LOCALSTORAGE_KEYS.psobAlerts}`);
          }
        }
      },
      'psob:refresh': (toAccountHash) => {
        accountHash = toAccountHash;
        if (localStorageEnabled) {
          psobAlert.data = JSON.parse(localStorage.getItem(`${toAccountHash}.${LOCALSTORAGE_KEYS.psobAlerts}`));
        }
      },
      'psob:removeAlert': () => {
        psobAlert = {
          alertKey: '',
          totalAlertCount: 0,
          attributes: {}
        };
      },
      'psob:removeInStorage': (accountHashToRemove) => {
        if (localStorageEnabled) {
          localStorage.removeItem(`${accountHashToRemove}.${LOCALSTORAGE_KEYS.psobAlerts}`);
        }
      }
    }
  });

  return template;
});
